import { history } from './history'

/**
 * Navigate from sagas / non-React code (replaces connected-react-router `push`).
 * Prefer `yield call(navigate, path)` in sagas so effects stay testable.
 *
 * @param {import('history').LocationDescriptor} to
 * @param {*} [state]
 */
export const navigate = (to, state) => {
  history.push(to, state)
}
